import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    Chart,
    BarSeries,
    ArgumentAxis,
    ValueAxis,
    Tooltip,
} from '@devexpress/dx-react-chart-material-ui';
import { Animation, EventTracker } from '@devexpress/dx-react-chart';

import { colors } from './../../utils/global';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    paperMain: {
        padding: '10px',
        textAlign: 'center',
        minHeight: "450px",
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    rotatedChart: {
        maxHeight: '400px',
        paddingTop: '30px'
    },
});

class RotatedBarChart extends Component {

    render() {
        const { classes, chartData } = this.props;

        return (
            <Chart
                className={classes.rotatedChart}
                data={chartData}
                rotated
            >
                <ArgumentAxis />
                <ValueAxis showLine max={7} />

                <BarSeries
                    valueField="val"
                    argumentField="type"
                    color={colors[8]}
                />


                <Animation />
                <EventTracker />
                <Tooltip />
            </Chart>
        );

    }
}

RotatedBarChart.propTypes = {
    chartData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default withStyles(styles)(RotatedBarChart);